<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button [text]="'ZURUECK' | translate"></ion-back-button>
    </ion-buttons>
    <ion-title>{{ 'PROJEKTE_UEBERSICHT' | translate }}</ion-title>
    <ion-buttons slot="end">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div class="padding-16">
    <work-ui-input-field iconName="search" (valueChange)="onSearchChange($event)"
                         label="SUCHEN"
                         placeholder="SUCHE_NACH_PROJEKT_ODER_KUNDE"
                         [(loadingState)]="searchLoadingState" />

    @if (searchLoadingState() === 'none' && searchTerm() && searchResults().length === 0) {
      <ion-item>
        <ion-label>{{ 'KEINE_SUCHTREFFER' | translate }}</ion-label>
      </ion-item>
    }
  </div>

  @if (searchResults().length > 0) {
    <ion-list>
      @for (searchResult of searchResults(); track searchResult.contact.id) {
        <work-office-global-megasearch-result-contact-and-projects [searchterm]="searchTerm()"
                                                                   (projectClicked)="onProjectClick($event)"
                                                                   [disableResultContactLinks]="true"
                                                                   [contactAndProjects]="searchResult" />
      }
    </ion-list>
  }
</ion-content>




